import React from "react";
import ReactPlayer from "react-player";
import ReplyIcon from "@mui/icons-material/Reply";
import DeleteIcon from "@mui/icons-material/Delete";
import { Done, DoneAll } from "@mui/icons-material";
import classes from "./audienceVideoMessage.module.scss";

const AudienceVideoMessage = ({
  userId,
  chat,
  reply,
  deleteMessage,
  src,
  doc,
  imgSrc,
}) => {
  const owner = parseInt(userId) === parseInt(chat.user_id);

  return (
    <div key={chat.key} className={classes.mainContainer}>
      <div>
        <div className={classes.messageContainer}>
          <ReactPlayer
            controls
            url={src}
            width="200px"
            height="auto"
            style={{ borderRadius: "7px" }}
            userId={userId}
          />
        </div>
        <img className={classes.userImg} src={imgSrc} alt="userImg" />
        {owner ? (
          <div>
            <ReplyIcon
              style={owner ? { fontSize: 20 } : { fontSize: 20, float: "left" }}
              onClick={() => reply(chat)}
            />
            <DeleteIcon onClick={() => deleteMessage(chat)} />
          </div>
        ) : (
          <div>
            <ReplyIcon
              style={owner ? { fontSize: 20 } : { fontSize: 20, float: "left" }}
              onClick={() => reply(chat)}
            />
          </div>
        )}
        {doc}
        <time>{chat.created_at}</time>
        {owner ? <span>{chat.seen ? <DoneAll /> : <Done />}</span> : null}
      </div>
    </div>
  );
};

export default AudienceVideoMessage;
